"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var validate_exports = {};
__export(validate_exports, {
  assertKeepAwakeEnabled: () => assertKeepAwakeEnabled,
  assertKeepAwakeTag: () => assertKeepAwakeTag,
  keepAwakeDefaultTag: () => keepAwakeDefaultTag,
  normalizeKeepAwakeTag: () => normalizeKeepAwakeTag
});
module.exports = __toCommonJS(validate_exports);
function assertKeepAwakeEnabled(value) {
  if (typeof value !== "boolean") {
    throw new Error("KeepAwake.setEnabled: enabled must be a boolean");
  }
}
var keepAwakeDefaultTag = "ExpoKeepAwakeDefaultTag";
function assertKeepAwakeTag(value, owner) {
  if (value !== void 0 && typeof value !== "string") {
    throw new Error(`KeepAwake.${owner}: tag must be a string`);
  }
}
function normalizeKeepAwakeTag(value) {
  return value !== null && value !== void 0 ? value : keepAwakeDefaultTag;
}
//# sourceMappingURL=validate.js.map
